import { render, staticRenderFns } from "./VoltDashboard.vue?vue&type=template&id=6cfbf0fb&"
import script from "./VoltDashboard.vue?vue&type=script&lang=js&"
export * from "./VoltDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports